module.exports = __webpack_public_path__ + "img/quote-right.199c156a.svg";